import { userParams } from '../user/paramConfig';
const dmaUserParams = {
    paramMapping: [
        ...userParams,
        {
            path: 'cbsPackageInfo[0]vendorCode',
            key: 'vendorCode',
        },
        {
            path: 'cbsPackageInfo[0]billingVendorProductCode',
            key: 'billingVendor',
        },
    ],
};

export { dmaUserParams };
